import React from 'react'
import DashboardMetricItem from '@components/pages/Dashboard/DashboardMetricItem.component'
import { metricDataToItemProps } from '@utils/dashboardMetrics.util'
import type { DashboardMetricItemData } from '../../../../types/dashboardMetrics.types'

const HUDDLE_METRIC_TILE_CLASS =
  'dashboard-huddle-metric-tile dashboard-metric-item'

export function HuddleMetricTile({
  metric,
  embedded = false,
}: {
  metric: DashboardMetricItemData
  embedded?: boolean
}): React.ReactElement {
  const props = metricDataToItemProps(metric)
  const tileClass = embedded
    ? 'dashboard-huddle-metric-tile-embedded dashboard-metric-item'
    : HUDDLE_METRIC_TILE_CLASS
  return (
    <DashboardMetricItem
      {...props}
      className={[tileClass, props.className].filter(Boolean).join(' ')}
    />
  )
}

export function HuddleMetricGrid({
  metrics,
}: {
  metrics: DashboardMetricItemData[]
}): React.ReactElement {
  return (
    <div className="dashboard-huddle-metric-grid">
      {metrics.map((m) => (
        <HuddleMetricTile key={m.id ?? m.leftLabel} metric={m} />
      ))}
    </div>
  )
}
